import actions from "./actions";

const initState = {
  data: [],
  schools: null,
  classrooms: null,
  grades: null,
  loggedUserData: null,
  lessonData: [],
  classroomsData: [],
  hashtagData: [],
  lessonhashtagData: [],
  collaborations: [],
  webData: [],
  clubprogressData: [],
  classroomprogressData: [],
  mcqProgress: [],
  myHashtagData: [],
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_GRAPH_DATA_SUCCESS:
      return { ...state, data: action.data };
    case actions.FETCH_METABASE_SUCCESS:
      return { ...state, metabase: action.data };
    case actions.FETCH_CONFIGS_DASHBOARD_SUCCESS:
      return { ...state, schools: action.schools, grades: action.grades };
    case actions.FETCH_CLASSROOM_CONFIGS_DASHBOARD_SUCCESS:
      return { ...state, classrooms: action.classrooms };
    case actions.FETCH_LOGGED_USER_DATA_SUCCESS:
      return { ...state, loggedUserData: action.data };
    case actions.FETCH_LESSON_DATA_SUCCESS:
      return { ...state, lessonData: action.lessonData };
    case actions.CHANGE_CLASSROOM_VALUE_SUCCESS:
      return { ...state, classroomsData: action.classroomsData };
    case actions.FETCH_TOP_HASHTAGS_SUCCESS:
      return { ...state, hashtagData: action.hashtagData };
    case actions.FETCH_TOP_LESSON_HASHTAGS_SUCCESS:
      return { ...state, lessonhashtagData: action.lessonhashtagData };
    case actions.FETCH_TOP_WEB_PLATFORMS_SUCCESS:
      return { ...state, webData: action.webData };
    case actions.FETCH_COLLABORATIONS_SUCCESS:
      return { ...state, collaborations: action.collaborations };
    case actions.FETCH_MCQPROGRESS_SUCCESS: // fixed typo here
      return { ...state, mcqProgress: action.mcqProgress };
    case actions.FETCH_CLUB_PROGRESS_SUCCESS:
      return { ...state, clubprogressData: action.clubprogressData };
    case actions.FETCH_CLASSROOM_PROGRESS_SUCCESS:
      return { ...state, classroomprogressData: action.classroomprogressData };
    case actions.FETCH_MY_TOP_HASHTAGS_SUCCESS:
      return { ...state, myHashtagData: action.myHashtagData };
    default:
      return state;
  }
}
